import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/client';
import FilterBar from '../../pages/article-list/FilterBar';

/** 挑選關聯新聞的篩選條件（與文章列表同一套）。 */
export interface RelatedFilterValues {
  title: string;
  status?: string;
  categoryId?: string;
  authorId?: string;
  tagId?: string;
  dateFrom?: number;
  dateTo?: number;
}

interface Props {
  /** Drawer 是否開著；關著時不去抓分類／作者選項。 */
  open: boolean;
  onChange: (patch: Partial<RelatedFilterValues>) => void;
}

/** 關聯新聞的篩選列：直接沿用文章列表的 FilterBar（手機自動變成可收合面板）。 */
export default function RelatedFilters({ open, onChange }: Props) {
  const categories = useQuery({ queryKey: ['categories'], queryFn: api.categories, enabled: open });
  const users = useQuery({ queryKey: ['users'], queryFn: api.users, enabled: open });
  return (
    <FilterBar
      categories={(categories.data ?? []).map((c) => ({ value: c.id, label: c.name }))}
      authors={(users.data ?? []).map((u) => ({ value: u.id, label: u.displayName }))}
      onTitle={(v) => onChange({ title: v })}
      onCategory={(v) => onChange({ categoryId: v })}
      onAuthor={(v) => onChange({ authorId: v })}
      onTag={(v) => onChange({ tagId: v })}
      onStatus={(v) => onChange({ status: v })}
      onDateRange={(from, to) => onChange({ dateFrom: from, dateTo: to })}
    />
  );
}
